var $ = require("jquery");
require("slick-carousel");
import "../stylesheets/slick";

//詳細js
$(function () {
  const spMax = 640;
  const slickSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    variableWidth: false,
    centerMode: false,
    prevArrow:
      '<button type="button" class="result-action-list-front__arrow result-action-list-front__arrow--prev">前へ</button>',
    nextArrow:
      '<button type="button" class="result-action-list-front__arrow result-action-list-front__arrow--next">次へ</button>',
    variableWidth: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          centerMode: false
        }
      }
    ],
    initialSlide: 0
  };

  //==========
  //リストに追加された事務所スライダー
  //==========
  var slider = $(".js-list-slider-front");
  slider.slick(slickSettings);

  $(".result-action-front__confirm .js-toggle-trigger").click(function () {
    //スライダーの親要素のdisplay:noneにより表示崩れを直す処理
    slider.slick("setPosition");

    //スライドの高さを統一する処理
    //一番高さの高いスライドと高さを取得し、全てのスライドにその高さを適用する
    var sliderMaxHeight = 0;

    $(".js-result-slider li").each(function (i, e) {
      var height = $(e).height();
      if (sliderMaxHeight < height) {
        sliderMaxHeight = height;
      }
    });
    $(".js-result-slider li").height(sliderMaxHeight);
  });

  //==========
  //リストに追加された事務所　横移動
  //==========
  $(window).on("scroll", function () {
    $(".result-action").css("left", -$(window).scrollLeft());
  });

  //==========
  //sp用js
  //==========
  if ($(window).width() <= spMax) {
    // 条件を変更する画面表示
    $(".js-conditions-trigger").on("click", function (e) {
      e.preventDefault();

      var condition = $($(this).attr("href"));

      condition.addClass("is-open");
    });

    $(".js-conditions-close").on("click", function (e) {
      e.preventDefault();

      var condition = $($(this).attr("href"));

      condition.removeClass("is-open");
    });

    //条件を変更するボタン追従
    $(window).on("load scroll", function () {
      var btn = $(".js-conditions-fixed");
      var scrollTop = $(window).scrollTop();
      var goal = $(".conditions__box").offset().top;
      if (scrollTop > goal) {
        btn.addClass("is-shown");
      } else {
        btn.removeClass("is-shown");
      }
    });
  }

  //==========
  //税理士・会計事務所一覧 スライダー
  //==========
  if ($(".js-slider").length > 0) {
    if ($(window).width() <= spMax) {
      $(".js-slider").not(".slick-initialized").slick({
        centerMode: true,
        slidesToShow: 1,
        variableWidth: true
      });
    } else {
      $(".js-slider.slick-initialized").slick("unslick");
    }
  }

  //==========
  //モーダル スライダー
  //==========
  $(".js-modal-trigger").on("click", function () {
    var target = $($(this).attr("href"));

    if (target.hasClass("is-open")) {
      return false;
    } else {
      target.addClass("is-open");
      overlayOn(target, target.data("fix"));

      if (target.find($(".js-detail-modal-slider"))) {
        var index = $(this).closest(".slick-slide").data("slick-index");
        $(".js-detail-modal-slider").slick("slickGoTo", index, true);
      }
    }
  });

  //========
  //条件をクリア 先頭で$宣言しているため挙動変化に注意
  //========
  $(".js--clear").on("click", function () {
    $(".js-prefecture-select").prop("selectedIndex", 0);
    $(".js-city-select").val("");
    $(".js-city-select").prop("disabled", true);
    $(".js-keyword").prop("value", "");
    $("input[type=checkbox]").prop("checked", false);
  });

  //========
  //表示件数変更
  //========
  $(".js-page_count").on("change", function () {
    var pageCount = $(".js-page_count").val();
    location.href = getOfficesUrl(pageCount);
  });

  //========
  //まとめてお問い合わせに追加/削除
  //========
  $(".js-inquiry-list").on("click", function () {
    var target = $(this);
    var branchId = target.data("branch");

    //========
    //登録済みの拠点一覧を元にリストの追加削除ボタンの整合性をチェックする
    //========
    if (target.hasClass("js-add-list")) {
      // リストに追加
      $.getJSON("/offices/inquiry_offices?command=add&id=" + branchId, function () {}).done(function (json) {
        // 検索結果内 会計事務所ボタン切り替え
        checkAddlistButton(json.branches);
        // リスト内会計事務所登録
        slider.slick("unslick");
        // 別タブで操作した場合を想定し、一覧を作成し直して同期を取る
        slider.empty();
        slider.append(json.data);
        slider.slick(slickSettings);
        initSlick();
        initListCountAndButton(json.count);
        if (json.result == "NG") {
          alert("一度にお問い合わせ可能な税理士・会計事務所は5件までです。");
          // 既に登録済みの拠点を登録しようとした時
        } else if (json.result == "DUP") {
          alert("選択した税理士・会計事務所は既にリストに登録されています。");
        }
      });
    } else if (target.hasClass("js-remove-list")) {
      // リストから削除
      $.getJSON("/offices/inquiry_offices?command=remove&id=" + branchId, function () {}).done(function (json) {
        // 検索結果内 会計事務所ボタン切り替え
        checkAddlistButton(json.branches);
        slider.slick("unslick");
        // 別タブで操作した場合を想定し、一覧を作成し直して同期を取る
        slider.empty();
        slider.append(json.data);
        slider.slick(slickSettings);
        initSlick();
        initListCountAndButton(json.count);
        if (json.result == "DUP") {
          alert("選択した税理士・会計事務所は既にリストから削除されています。");
        }
      });
    } else if (target.hasClass("js-remove-mini-list")) {
      // リストから削除 in まとめてお問い合わせ
      $.getJSON("/offices/inquiry_offices?command=remove&id=" + branchId, function () {}).done(function (json) {
        // 検索結果内 会計事務所ボタン切り替え
        checkAddlistButton(json.branches);
        slider.slick("unslick");
        // 別タブで操作した場合を想定し、一覧を作成し直して同期を取る
        slider.empty();
        slider.append(json.data);
        slider.slick(slickSettings);
        initSlick();
        initListCountAndButton(json.count);
        if (json.result == "DUP") {
          alert("選択した税理士・会計事務所は既にリストから削除されています。");
        }
      });
    }
  });

  //========
  //まとめてお問い合わせから削除(リスト)
  //========

  $(".js-list-slider-front").on("click", ".js-inquiry-mini-list", function () {
    var target = $(this);
    var branchId = target.data("branch");

    function disabledInquiryButton() {
      var count = $(".button-primary-front__count").text();
      if (count == 1) {
        $(".button-primary-front").addClass("is-disabled");
      }
    }

    if (target.hasClass("js-remove-mini-list")) {
      // リストから削除 in まとめてお問い合わせ
      $.getJSON("/offices/inquiry_offices?command=remove&id=" + branchId, function () {}).done(function (json) {
        // 検索結果内 会計事務所ボタン切り替え
        checkAddlistButton(json.branches);
        slider.slick("unslick");
        // 別タブで操作した場合を想定し、一覧を作成し直して同期を取る
        slider.empty();
        slider.append(json.data);
        slider.slick(slickSettings);
        initSlick();
        initListCountAndButton(json.count);
        if (json.result == "DUP") {
          alert("選択した税理士・会計事務所は既にリストから削除されています。");
        }
      });
      if ($("#forced_disclosure_flag").val() == "true") {
        disabledInquiryButton();
      }
    }
  });

  //========
  //まとめてお問い合わせ遷移
  //========
  $("a.button-primary-front").on("click", function () {
    // 値を保存できないため近くの数値を取得。遷移先は_show_js.html.slimに委託
    var count = $(".button-primary-front__count").text();
    if (count > 0) {
      location.href = getInquiryUrl();
    } else {
      location.href = getOfficesInquiryUrl();
    }
  });

  //==========
  //汎用function
  //==========
  // スクロール禁止状態にする
  function htmlFix() {
    var st = $(window).scrollTop() * -1;
    $("html").addClass("is-fixed");
    $("body").css("top", st);
  }

  //スクロール禁止状態を解除する
  function htmlScroll() {
    var st = parseFloat($("body").css("top")) * -1;
    $("html").removeClass("is-fixed").scrollTop(st);
    $("body").removeAttr("style");
  }

  //オーバーレイ表示
  function overlayOn(location, mode) {
    if ($(".overlay").length < 1) {
      location.after('<div class="overlay js-overlay"></div>');

      if (!(mode == "none")) {
        htmlFix();
      }

      $(".overlay").animate(
        {
          opacity: 1
        },
        200
      );
    }
  }
  //リスト件数の表示非表示の制御
  function initListCountAndButton(count) {
    $(".result-action-front__number").text(count + "件");
    $(".button-primary-front__count").text(count);
    if (count == 0) {
      // リストの数が0件の時、display:noneのクラスを付加する
      if (!$(".button-primary-front__count").hasClass("js-no-list")) {
        $(".button-primary-front__count").addClass("js-no-list");
      }
      if (!$(".result-action-front__text").hasClass("js-no-list")) {
        $(".result-action-front__text").addClass("js-no-list");
      }
    } else {
      // リストの数が1件以上の時、display:noneのクラスを外す
      if ($(".button-primary-front__count").hasClass("js-no-list")) {
        $(".button-primary-front__count").removeClass("js-no-list");
      }
      if ($(".result-action-front__text").hasClass("js-no-list")) {
        $(".result-action-front__text").removeClass("js-no-list");
      }
    }
  }

  function changeResultClass(_target) {
    // リストに追加・削除のcss反転
    _target.toggleClass("js-add-list");
    _target.toggleClass("js-remove-list");
  }
  //検討リストボタンの文言制御
  function checkAddlistButton(branches) {
    $(".js-remove-list").each(function (index, button) {
      if (!branches.includes($(button).attr("data-branch"))) {
        changeResultClass($(button));
        $(button).text("検討リストに追加");
      }
    });
    $(".js-add-list").each(function (index, button) {
      if (branches.includes($(button).attr("data-branch"))) {
        changeResultClass($(button));
        $(button).text("検討リストから削除");
      }
    });
  }
  //スライドの高さ調整
  function initSlick() {
    slider.slick("setPosition");

    //スライドの高さを統一する処理
    //一番高さの高いスライドと高さを取得し、全てのスライドにその高さを適用する
    var sliderMaxHeight = 0;

    $(".js-result-slider li").each(function (i, e) {
      var height = $(e).height();
      if (sliderMaxHeight < height) {
        sliderMaxHeight = height;
      }
    });
    if (sliderMaxHeight > 0) {
      $(".js-result-slider li").height(sliderMaxHeight);
    }
  }

  //==========
  //詳細スライダー
  //==========
  let slickImages = 4;
  if ($(window).width() <= spMax) {
    var centerFlag = true;
    slickImages = 3;
  } else {
    var centerFlag = false;
  }

  let infiniteFlag = true;
  if ($(".js-detail-slider li").length < slickImages) {
    infiniteFlag = false;
  }

  $(".js-detail-slider").slick({
    slidesToShow: 1,
    variableWidth: true,
    centerMode: centerFlag,
    infinite: infiniteFlag
  });

  //==========
  //詳細モーダル内スライダー
  //==========
  $(".js-detail-modal-slider").slick({
    slidesToShow: 1,
    variableWidth: true,
    centerMode: true
  });

  //==========
  //モーダル スライダー
  //==========
  $(".js-modal-trigger").on("click", function () {
    var target = $($(this).attr("href"));

    if (target.hasClass("is-open")) {
      return false;
    } else {
      target.addClass("is-open");
      overlayOn(target, target.data("fix"));

      if (target.find($(".js-detail-modal-slider"))) {
        var index = $(this).closest(".slick-slide").data("slick-index");
        $(".js-detail-modal-slider").slick("slickGoTo", index, true);
      }
    }
  });
});

//==========
//まとめてお問い合わせボタン 追従範囲指定処理
//==========
$(window).on("load scroll", function () {
  var resultAction = $(".js-result-action");
  if (resultAction.length == 0) return;
  var footerTop = $(".footer").offset().top;
  var resultActionBottom = resultAction.offset().top + resultAction.height();

  if (resultActionBottom > footerTop) {
    resultAction.removeClass("is-shown");
  } else {
    resultAction.addClass("is-shown");
  }
});

//==========
//この事務所にお問い合わせボタン 追従範囲指定処理
//==========
$(window).on("load scroll", function () {
  var resultAction = $(".js-inquiry-action");
  if (resultAction.length == 0) return;
  var footerTop = $(".ly-inner").offset().top;
  var resultActionBottom = resultAction.offset().top;
  if (resultActionBottom < footerTop) {
    resultAction.removeClass("is-shown");
  } else {
    resultAction.addClass("is-shown");
  }
});
